<template>

    <div class="flex sm:h-screen sm:content-center sm:items-center">
        <div class="container mx-auto">

            <div class="container mx-auto w-full sm:max-w-lg">
                <div class="bg-white sm:rounded-lg sm:shadow-xl">

                    <div class="w-full px-6 flex content-center mb-4">
                        <h1 class="text-3xl font-bold text-black pt-4">
                            <router-link class="text-blue-500" to="/login">
                                <i class="far fa-chevron-circle-left mr-4"></i>
                            </router-link>
                        </h1>
                        <h1 class="text-3xl font-bold text-black pt-4">Password Reset</h1>
                    </div>

                    <div class="px-6 mb-4">
                        <div class="bg-blue-700 mb-8 p-4 text-white" v-if="status !== null">
                            <span>{{ status }}</span>
                        </div>
                        <p class="mb-6 text-left">Enter the details below and click 'reset password' to finish resetting your password.</p>

                        <div class="block pb-4" data-children-count="1">
                            <label class="block text-gray-700 font-bold mb-2" for="token">Reset Token</label>
                            <input class="bg-grey-100 appearance-none border rounded w-full py-3 px-4 text-gray-600 leading-tight focus:outline-none" type="text" name="token" id="token" v-model="token" disabled required>
                        </div>

                        <div class="block pb-4" data-children-count="1">
                            <label class="block text-gray-700 font-bold mb-2" for="email">Email Address</label>
                            <input class="bg-grey-100 appearance-none border rounded w-full py-3 px-4 text-gray-600 leading-tight focus:outline-none" type="email" name="email" id="email" v-model="email" disabled required>
                        </div>

                        <div class="block pb-6" data-children-count="1">
                            <label class="block text-gray-700 font-bold mb-2" :class="{'text-red-600': error}" for="password">Password</label>
                            <input class="bg-grey-100 appearance-none border rounded w-full py-3 px-4 text-black leading-tight focus:outline-none" :class="{'border-red-400 focus:border-red-600 text-red-600': error, 'focus:border-indigo-400': !error }" type="password" name="password" id="password" v-model="password" required>
                        </div>

                        <div class="block pb-6" data-children-count="1">
                            <label class="block text-gray-700 font-bold mb-2" :class="{'text-red-600': error}" for="confirm_password">Confirm Password</label>
                            <input class="bg-grey-100 appearance-none border rounded w-full py-3 px-4 text-black leading-tight focus:outline-none" :class="{'border-red-400 focus:border-red-600 text-red-600': error, 'focus:border-indigo-400': !error }" type="password" name="password_confirmation" id="password_confirmation" v-model="password_confirmation" required @keyup.enter="reset()">
                        </div>
                    
                    </div>

                    <div class="bg-grey-100 border-t border-b border-grey-300 rounded-b-lg px-6 py-4">
                        <div class="flex justify-between items-center">
                            <button class="bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded py-2 px-6 focus:outline-none mx-auto" v-on:click="reset()">
                                <span v-if="!resetting">Reset Password</span>
                                <span v-if="resetting"><i class="fa fa-circle-notch fa-spin logging-in"></i></span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <footer class="container mx-auto w-full sm:max-w-md mt-10">
                <div class="container mx-auto max-w-md text-center">
                    <p class="text-gray-500">
                        &copy; 2017-2019 — Viral News Service
                    </p>
                </div>
            </footer>
        </div>

    </div>

</template>

<script>

    import * as Config from '@/config'

	export default {
        name: 'PasswordResetFinal',
		data () {
			return {
                msg: 'Welcome to Your Vue.js App',
                token: null,
                email: null,
                password: null,
                password_confirmation: null,
                resetting: false,
                error: false,
                status: null,
                
			}
        },
        mounted() {
            this.token = this.$route.params.token
            this.email = this.$route.query.email
        },
        methods: {

            reset() {
                var _this = this
                this.resetting = true;

                this.$http.post(Config.apiPath + "/api/password/reset", {
                    token: this.token,
                    email: this.email,
                    password: this.password,
                    password_confirmation: this.password_confirmation
                }).then((response) => {
                    this.$set(this, 'resetting', false)
                    this.$set(this, 'status', response.data.status)
                    _this.$router.push({
                        path: '/login',
                        query: {
                            status: 'password_reset'
                        }
                    })
                }).catch(error => {
                    _this.$swal(
                        'Oops!',
                        'Something went wrong.',
                        'error'
                    )
                    this.$set(this, 'status', null)
                    this.$set(this, 'resetting', false)
                })
            }
        }
    }

</script>